import { DepositCurrencyTypeData } from "depositCurrencyTypeData";

/**
 * Данные видов вклада
 */
export class DepositData {
  /**
   * Заголовок.
   */
  public Caption: string = "";

  /**
   * Ключи для переключения 
   */
  public GroupKey: string = "";

  public ActiveCurrency: string = '';

  public ActiveTerm: string | null = null;

  /**
   * Валютные разновидности вклада
   */
  public CurrencyChilds: Array<DepositCurrencyTypeData> = [];

  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  constructor(src: any = null) {
    if (src) {
      this.Caption = src.groupName ?? "";
      this.GroupKey = src.groupKey ?? "";
    }
  }
}
